import React from 'react'
import SUPLogo from '../assets/SUP-logo.jpg'

import { Card, CardContent, Typography } from '@mui/material'
import useIsMobile from '../hooks/useIsMobile'

const RegistrationCard = ({
  children,
  cardIsTallerThanBody = false,
  title,
  sx = {},
}) => {
  const isMobile = useIsMobile()

  return (
    <Card
      sx={{
        ...sx,
        textAlign: 'center',
        minWidth: isMobile ? '100%' : '400px',
        width: isMobile ? '100%' : null,
        height: isMobile ? '100%' : null,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      id={'registration-card'}
    >
      <CardContent>
        <img src={SUPLogo} className={'auth-flow-logo'} />
        {title && (
          <Typography variant={'h5'} sx={{ mb: '16px' }}>
            {title}
          </Typography>
        )}
        {children}
      </CardContent>
    </Card>
  )
}

export const WrappedCard = (props) => (
  <div className='full-page-center'>
    <RegistrationCard {...props} />
  </div>
)

export default RegistrationCard
